import { defineMessages } from "react-intl";

const PREFIX = "HomeNavigationBlocks";
export default defineMessages({
  slides: {
    id: `${PREFIX}.slides`,
    defaultMessage: "Slides",
  },
  slidesDescription: {
    id: `${PREFIX}.slides.description`,
    defaultMessage: "In the Slides section you will find the full list of available reports.",
  },
  maps: {
    id: `${PREFIX}.maps`,
    defaultMessage: "Maps",
  },
  mapsDescription: {
    id: `${PREFIX}.maps.description`,
    defaultMessage: "The Map section displays statistics on the world map by data source.",
  },
  bulkExport: {
    id: `${PREFIX}.bulkExport`,
    defaultMessage: "Bulk export",
  },
  bulkExportDescription: {
    id: `${PREFIX}.bulkExport.description`,
    defaultMessage: "In the Bulk export section you can configure the data export by sources and it's parameters.",
  },
  dashboards: {
    id: `${PREFIX}.dashboards`,
    defaultMessage: "Dashboards",
  },
  dashboardsDescription: {
    id: `${PREFIX}.dashboards.description`,
    defaultMessage: "The Dashboard section allows user to create and manage dashboards.",
  },
});
